import { download, generateCsv, mkConfig } from "export-to-csv"
import { DateTime } from "luxon"
import { useCallback } from "react"
import { useDateTime } from "../../../../localization/useDateTime"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { CustomerUsageEntry } from "../statisticsTypes"

type useExportCustomerUsageToCsvParams = Readonly<{
    data: CustomerUsageEntry[] | null | undefined
    startDate: DateTime
    endDate: DateTime
}>

export function useExportCustomerUsage({ data, startDate, endDate }: useExportCustomerUsageToCsvParams) {
    const dateTimeFactory = useDateTime()
    const { l10n } = useAppLocalization()

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-usage-rate-${dateTimeFactory.formatDate(startDate)}_${dateTimeFactory.formatDate(endDate)}`,
    })

    const mapEntryToCsvRow = (entry: CustomerUsageEntry) => {
        return {
            From: dateTimeFactory.formatDate(startDate),
            To: dateTimeFactory.formatDate(endDate),
            Resource: entry.resource.displayName,
            "Usage rate": entry.usageRate,
        }
    }

    return useCallback(() => {
        let exportRows: ReturnType<typeof mapEntryToCsvRow>[]

        if (data && data.length > 0) {
            exportRows = data.map((entry) => mapEntryToCsvRow(entry))
        } else {
            exportRows = [mapEntryToCsvRow({} as CustomerUsageEntry)]
        }

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }, [dateTimeFactory, data, startDate, endDate, l10n])
}
